import PropTypes from 'prop-types';
import React from 'react';

/**
 * Componente de debug para mostrar información técnica de imágenes optimizadas
 * Solo se renderiza en modo desarrollo para ayudar con el debugging
 */
function ImageDebug({ config, fallbackUrl, sizesString, srcset, url }) {
  if (process.env.NODE_ENV !== 'development') {
    return null;
  }

  return (
    <div style={{ marginTop: '10px', fontSize: '12px', background: '#f5f5f5', padding: '10px' }}>
      <div style={{ fontWeight: 'bold', marginBottom: '5px' }}>🔍 Debug - Imagen Responsive:</div>
      <div>
        <strong>URL Original:</strong> {url}
      </div>
      <div>
        <strong>Fallback URL (src):</strong> {fallbackUrl}
      </div>
      <div>
        <strong>Sizes:</strong> {sizesString}
      </div>
      <div>
        <strong>SrcSet (navegador elegirá automáticamente):</strong>
      </div>
      <div style={{ fontSize: '10px', margin: '5px 0' }}>
        {srcset.split(', ').map((src, index) => (
          <div key={index} style={{ margin: '2px 0', fontFamily: 'monospace' }}>
            {src}
          </div>
        ))}
      </div>
      <div>
        <strong>Breakpoints:</strong>
      </div>
      <div style={{ margin: '5px 0', paddingLeft: '20px' }}>
        <div>Mobile: {config.sizes.mobile}</div>
        <div>
          Tablet (≥{config.breakpoints.tablet}): {config.sizes.tablet}
        </div>
        <div>
          Desktop (≥{config.breakpoints.desktop}): {config.sizes.desktop}
        </div>
      </div>
      <div style={{ marginTop: '10px', padding: '8px', background: '#e8f4fd', borderRadius: '4px' }}>
        <strong>💡 Cómo funciona:</strong>
        <div style={{ margin: '5px 0' }}>
          El navegador usa el <code>srcset</code> y <code>sizes</code> para elegir automáticamente la mejor imagen según el tamaño de pantalla y la densidad de
          píxeles. El <code>src</code> solo se usa como fallback para navegadores antiguos.
        </div>
        <div style={{ margin: '5px 0', fontSize: '11px' }}>
          <strong>Ejemplo iPhone SE (375px):</strong> Con <code>sizes="100vw"</code> y densidad 2x, el navegador necesita ~750px, por lo que elegirá{' '}
          <code>file_800.avif</code>. Para evitar esto, usa <code>sizes="(max-width: 480px) 100vw"</code>.
        </div>
      </div>
    </div>
  );
}

ImageDebug.propTypes = {
  config: PropTypes.object.isRequired,
  fallbackUrl: PropTypes.string.isRequired,
  sizesString: PropTypes.string.isRequired,
  srcset: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
};

export default ImageDebug;
